export default {
  blog: {
    loading: false,
    posts: []
  }
}
